export const config = (theirMonthOffer, discountDuration) => ({
  youGetTitle: 'You get',
  yourFriendGetsTitle: 'Your friend gets',
  youGetDescription: 'when their first order is delivered',
  yourFriendGetsDescription: `off their first order + ${theirMonthOffer} off their first ${discountDuration}`,
})
